
module.exports = function()
{
    this.provider = null; 
    this.terminalId = null;
    this.isConnected = false;  
    this.errorMessage = null;
    this.underlyingDriver = null;
    
}
